// extracted by mini-css-extract-plugin
export default {"container":"page404_container__3ua3e"};